import { useQuery } from "react-query";
import { publicRequest } from "utils";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

import {
  filterDateRangeReducer,
  filterDateRangeInitialValue
} from "reducers/filterDateRange";
import { useReducer } from "react";
import { useMeta } from "hooks";

export interface useBlogsArgs {
  currentPage: number;
  category_id?: number | string;
}

export const useBlogs = ({ currentPage, category_id }: useBlogsArgs) => {
  const [{ filterDates, formatedFilterDates }, setFiltersDateRange] =
    useReducer(filterDateRangeReducer, filterDateRangeInitialValue);
  const { setMetaTags } = useMeta();

  const { language } = useSelector((state: RootState) => state.global);
  const PAGE_SIZE = 12;

  const { data: blogs } = useQuery(
    [language, currentPage, category_id, formatedFilterDates, "blogs"],
    () =>
      publicRequest({
        url: `/api/blogs/${language}?page=${currentPage}&per_page=${PAGE_SIZE}&start_date=${
          formatedFilterDates?.startDate
        }&end_date=${formatedFilterDates?.endDate}${
          category_id ? `&category_id=${category_id}` : ""
        }`,
        method: "get"
      }),
    {
      onSuccess: (res) => {
        setMetaTags(res?.data?.meta);
      }
    }
  );

  return {
    blogs: blogs?.data?.data,
    maxPages: blogs?.data?.max_pages,
    PAGE_SIZE,
    filterDates,
    setFiltersDateRange
  };
};
